import Typography from "@mui/material/Typography";
import LectureImage from '../../../images/lecture.png';
import IconBook from '../../../images/bookicon.png';
import IconSchool from '../../../images/wallet.png';
import IconGuide from '../../../images/handimg.png';
import IconFun from '../../../images/trophyicon.png';
import { useTheme, useMediaQuery, Grid } from "@mui/material";
import { motion } from "framer-motion";

const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, ease: "easeOut" }
    }
};

export default function ForgetBoringLectures() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <div style={{
            fontFamily: 'Rubik',
            backgroundColor: '#f7f9fc',
            padding: isMobile ? '48px 16px' : '64px 32px',
        }}>
            {/* Title */}
            <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
            >
                <Typography
                    sx={{
                        fontSize: { xs: '36px', sm: '48px', md: '64px' },
                        fontWeight: 700,
                        color: '#3165F6',
                        textAlign: 'center',
                        marginBottom: '32px',
                        lineHeight: 1.2 ,fontFamily: 'Montserrat',
                    }}
                >
                    Forget Boring Lectures
                </Typography>
            </motion.div>

            {/* Content Container */}
            <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
            >
                <div style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    padding: isMobile ? '24px' : '32px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: '32px',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}>
                    {/* Image */}
                    <motion.div variants={fadeInUp} style={{ flex: isMobile ? 'unset' : 1 }}>
                        <img
                            src={LectureImage}
                            alt="Learning session"
                            style={{
                                width: '100%',
                                maxWidth: isMobile ? '100%' : '500px',
                                borderRadius: '16px'
                            }}
                        />
                    </motion.div>

                    {/* Text + Features */}
                    <motion.div
                        variants={fadeInUp}
                        style={{
                            flex: isMobile ? 'unset' : 1,
                            width: '100%',
                            marginTop: isMobile ? '24px' : '0'
                        }}
                    >
                        <Typography sx={{
                            fontSize: isMobile ? '18px' : '22px',
                            fontWeight: 600,
                            color: '#000000',
                            marginBottom: '24px',
                            textAlign: isMobile ? 'center' : 'left' ,fontFamily: 'Poppins',
                        }}>
                            Real learning happens when you roll up your sleeves and create!
                        </Typography>

                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                            gap: '24px'
                        }}>
                            {[
                                {
                                    icon: IconBook,
                                    title: "Learn by Doing",
                                    color: "#3165F6",
                                    desc: "Our experiential style makes STEM click through real action."
                                },
                                {
                                    icon: IconSchool,
                                    title: "School-Friendly",
                                    color: "#F97316",
                                    desc: "Our programs sync with what you’re already learning."
                                },
                                {
                                    icon: IconGuide,
                                    title: "Top-Notch Guides",
                                    color: "#6366F1",
                                    desc: "Our trainers are experts who make STEM inspiring and simple."
                                },
                                {
                                    icon: IconFun,
                                    title: "Seriously Fun",
                                    color: "#10B981",
                                    desc: "We turn learning into an adventure you’ll love."
                                }
                            ].map((item, index) => (
                                <motion.div
                                    key={index}
                                    variants={fadeInUp}
                                    style={{ display: 'flex', alignItems: 'flex-start' }}
                                >
                                    <img
                                        src={item.icon}
                                        alt={item.title}
                                        style={{
                                            width: isMobile ? 28 : 35,
                                            marginRight: 12,
                                            marginTop: 4
                                        }}
                                    />
                                    <div>
                                        <Typography sx={{
                                            fontSize: isMobile ? '16px' : '18px',
                                            fontWeight: 600,
                                            color: item.color,
                                            marginBottom: '4px',fontFamily: 'Montserrat',
                                        }}>
                                            {item.title}
                                        </Typography>
                                        <Typography sx={{
                                            fontSize: isMobile ? '14px' : '15px',
                                            color: '#4B5563',fontFamily: 'Poppins',
                                        }}>
                                            {item.desc}
                                        </Typography>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </motion.div>
        </div>
    );
}
